var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionStepInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9233 6.77855C12.9233 6.26874 12.5101 5.85547 12.0003 5.85547C11.4905 5.85547 11.0772 6.26874 11.0772 6.77855V11.0772H6.77855C6.26874 11.0772 5.85547 11.4905 5.85547 12.0003C5.85547 12.5101 6.26874 12.9233 6.77855 12.9233H11.0772V17.222C11.0772 17.7318 11.4905 18.145 12.0003 18.145C12.5101 18.145 12.9233 17.7318 12.9233 17.222V12.9233H17.222C17.7318 12.9233 18.145 12.5101 18.145 12.0003C18.145 11.4905 17.7318 11.0772 17.222 11.0772H12.9233V6.77855Z",
    fill: "#616264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionStepInactive);
export default __webpack_public_path__ + "static/media/accordion_step_inactive.e72e077350c2dd4d3b088533fc126afb.svg";
export { ForwardRef as ReactComponent };